import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import StateInterface from '../../redux/types';
import useFeatureToggle from '../useFeatureToggle';
import useUserTracking from './useUserTracking';
import useNeverShowShopToClub from './useNeverShowShopToClub';
import { ShopToClubConfigState } from 'Common/appshell_types/remoteConfigType';
import { HeaderModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';
import useGa from 'Client/hooks/useGa';

const useShowPromoBarBanner = (): boolean | undefined => {
    const { clubHeaderBarBanner, p100ShowS2CBanner } = useFeatureToggle();
    const { isRegistered, didLoginFinishOnce } = useUserTracking();
    const [hasDismissCookie] = useNeverShowShopToClub();
    const gaTracking = useGa();
    const { headerMode } = useLayoutByPage();
    const promoConfiguration = useSelector<StateInterface, ShopToClubConfigState>(
        state => state.configurations.shopToClub
    );

    const isShopToClubEnabled = promoConfiguration.isEnabled;
    const correctHeaderMode = headerMode !== HeaderModeType.NONE;
    const isVisibleByDefault =
        !hasDismissCookie &&
        !isRegistered &&
        correctHeaderMode &&
        clubHeaderBarBanner &&
        didLoginFinishOnce &&
        isShopToClubEnabled;

    useEffect(() => {
        if (isVisibleByDefault) {
            gaTracking.trackVariation('p100ShowS2CBanner', p100ShowS2CBanner);
        }
    }, [gaTracking, isVisibleByDefault, p100ShowS2CBanner]);

    return isVisibleByDefault && p100ShowS2CBanner;
};

export default useShowPromoBarBanner;
